import type { ApiResponse, OrganizationBrandItem } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { useAuth } from '@/contexts/auth-context';

const fetchOrganizationBrands = async (): Promise<OrganizationBrandItem[]> => {
  const { data } = await api.get<ApiResponse<OrganizationBrandItem[]>>('/dashboard/brands');
  return data.data ?? [];
};

export const useOrganizationBrandsQuery = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<OrganizationBrandItem[], Error>({
    queryKey: ['organizationBrands'],
    queryFn: fetchOrganizationBrands,
    staleTime: 5 * 60 * 1000, // 5 minutes - brands rarely change
    enabled: isAuthenticated,
  });
};
